import { render, staticRenderFns } from "./PatientTabContent.vue?vue&type=template&id=146b23f6"
import script from "./PatientTabContent.vue?vue&type=script&lang=js"
export * from "./PatientTabContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports